/**
 * Figma-exact privacy shield (filled, with the check cut out), extracted 1:1
 * from the Live-Palmistry-4.0 design (LPR_Onboarding_Step21 → "Shield Icon").
 * Uses `currentColor` so the colour is driven by the row's `text-*` class.
 */
export function ShieldCheckIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 15 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.50293 0C7.50293 0 9.02385 1.05622 10.7568 1.77051C12.4175 2.45819 13.7428 2.52585 13.75 2.52637V7.7793C13.75 9.2227 13.5154 10.7976 11.5762 12.5713C9.64111 14.341 7.50276 14.9992 7.5 15C7.5 15 5.36327 14.3451 3.42383 12.5713C1.48769 10.8005 1.25 9.2227 1.25 7.7793V2.52637C1.25605 2.52607 2.58651 2.45941 4.25 1.77051C5.97357 1.06007 7.4867 0.0112641 7.50293 0ZM11.0674 4.97461C10.8233 4.73053 10.4267 4.73053 10.1826 4.97461L6.45801 8.69922L5.2334 7.47461C4.98931 7.23069 4.59363 7.23059 4.34961 7.47461C4.10559 7.71863 4.10569 8.11431 4.34961 8.3584L6.0166 10.0254C6.26069 10.2693 6.65637 10.2694 6.90039 10.0254L11.0674 5.8584C11.3111 5.61435 11.3112 5.21859 11.0674 4.97461Z" />
    </svg>
  )
}
